/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ButtonOptions } from './ButtonOptions';
import {
    ButtonOptionsFromJSON,
    ButtonOptionsFromJSONTyped,
    ButtonOptionsToJSON,
    ButtonOptionsToJSONTyped,
} from './ButtonOptions';
import type { MultiButtonOptions } from './MultiButtonOptions';
import {
    MultiButtonOptionsFromJSON,
    MultiButtonOptionsFromJSONTyped,
    MultiButtonOptionsToJSON,
    MultiButtonOptionsToJSONTyped,
} from './MultiButtonOptions';

/**
 * 
 * @export
 * @interface ButtonCreateRequest
 */
export interface ButtonCreateRequest {
    /**
     * The ID of the `Domain` object.
     * @type {string}
     * @memberof ButtonCreateRequest
     */
    domain: string;
    /**
     * Whether this `Button` is active
     * @type {boolean}
     * @memberof ButtonCreateRequest
     */
    active: boolean;
    /**
     * The display name of this `Button`
     * @type {string}
     * @memberof ButtonCreateRequest
     */
    name: string;
    /**
     * The type of this `Button`
     * @type {string}
     * @memberof ButtonCreateRequest
     */
    type: ButtonCreateRequestTypeEnum;
    /**
     * Display options for this `Button` (size, placement, etc.)
     * @type {ButtonOptions}
     * @memberof ButtonCreateRequest
     */
    options: ButtonOptions;
    /**
     * Options specific to multi-button layouts, or null for single buttons
     * @type {MultiButtonOptions}
     * @memberof ButtonCreateRequest
     */
    multiButtonOptions?: MultiButtonOptions;
    /**
     * A list of IDs belonging to the `Action`s that should be associated with this `Button`.
     * @type {Array<string>}
     * @memberof ButtonCreateRequest
     */
    actions: Array<string>;
    /**
     * A list of IDs belonging to the `Conditions`s that should be associated with this `Button`.
     * @type {Array<string>}
     * @memberof ButtonCreateRequest
     */
    conditions: Array<string>;
}


/**
 * @export
 */
export const ButtonCreateRequestTypeEnum = {
    Single: 'SINGLE',
    Multi: 'MULTI',
    Full: 'FULL',
    Dots: 'DOTS'
} as const;
export type ButtonCreateRequestTypeEnum = typeof ButtonCreateRequestTypeEnum[keyof typeof ButtonCreateRequestTypeEnum];


/**
 * Check if a given object implements the ButtonCreateRequest interface.
 */
export function instanceOfButtonCreateRequest(value: object): value is ButtonCreateRequest {
    if (!('domain' in value) || value['domain'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('options' in value) || value['options'] === undefined) return false;
    if (!('actions' in value) || value['actions'] === undefined) return false;
    if (!('conditions' in value) || value['conditions'] === undefined) return false;
    return true;
}

export function ButtonCreateRequestFromJSON(json: any): ButtonCreateRequest {
    return ButtonCreateRequestFromJSONTyped(json, false);
}

export function ButtonCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ButtonCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'domain': json['domain'],
        'active': json['active'],
        'name': json['name'],
        'type': json['type'],
        'options': ButtonOptionsFromJSON(json['options']),
        'multiButtonOptions': json['multiButtonOptions'] == null ? undefined : MultiButtonOptionsFromJSON(json['multiButtonOptions']),
        'actions': json['actions'],
        'conditions': json['conditions'],
    };
}

export function ButtonCreateRequestToJSON(json: any): ButtonCreateRequest {
    return ButtonCreateRequestToJSONTyped(json, false);
}

export function ButtonCreateRequestToJSONTyped(value?: ButtonCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'domain': value['domain'],
        'active': value['active'],
        'name': value['name'],
        'type': value['type'],
        'options': ButtonOptionsToJSON(value['options']),
        'multiButtonOptions': MultiButtonOptionsToJSON(value['multiButtonOptions']),
        'actions': value['actions'],
        'conditions': value['conditions'],
    };
}

